import type { DataTableAction, DataTableColumn } from '@/components/data-table/data-table.interface'

import { MemberNameCell } from './member-name-cell.atom'
import { MemberRoleCell } from './member-role-cell.atom'
import type { OrganizationMember, OrganizationRoleKey } from './members.interface'

export const createMemberColumnList = (
  canManageMembers: boolean,
  onRoleChange: (memberId: string, memberRole: OrganizationRoleKey) => void
): DataTableColumn<OrganizationMember>[] => [
  { id: 'name', header: 'Member', cell: (row) => <MemberNameCell member={row} /> },
  {
    id: 'memberRole',
    header: 'Role',
    cell: (row) => (
      <MemberRoleCell
        member={row}
        canManageMembers={canManageMembers}
        onRoleChange={onRoleChange}
      />
    ),
    width: '140px',
  },
  {
    id: 'joined',
    header: 'Joined',
    cell: (row) => (
      <span className="text-muted-foreground">{row.createdAt.toLocaleDateString()}</span>
    ),
    width: '120px',
  },
]

export const createMemberActionList = (
  canManageMembers: boolean,
  currentUserId: string | null,
  onRemoveMember: (memberId: string) => void
): DataTableAction<OrganizationMember>[] => {
  if (!canManageMembers) return []

  return [
    {
      id: 'remove',
      label: 'Remove',
      onClick: (row) => onRemoveMember(row.id),
      variant: 'destructive',
      isDisabled: (row) => row.isCurrentUser || row.clerkUserId === currentUserId,
    },
  ]
}
